import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const pains = ['Noche buscando prompts que nunca quedan bien para el mercado argentino', 'Copies armados a las corridas sin estructura ni framework probado', 'Siempre los mismos creativos porque no tenés un banco de ideas serio', 'El CTR bajo, el CPM alto, el ROAS que no cierra — sin sistema de diagnóstico', 'Clientes con presupuestos distintos sin material diferenciado — trabajás el doble y cobrás lo mismo', 'Semana agotada, el lunes volvió a empezar el mismo ciclo'];
  return <section className="py-14 px-4 max-w-4xl mx-auto pt-[5px] pb-[5px] space-y-[0px]" data-id="element-209">
      <FadeIn data-id="element-210">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6" data-id="element-211">
          ¿Cuántas noches más vas a perder así?
        </h2>

        <div className="text-lg md:text-xl text-gray-300 text-center mb-10 space-y-4 max-w-3xl mx-auto" data-id="element-212">
          <p data-id="element-213">
            Sos media buyer, freelancer o emprendedor. Amás los resultados. Pero
            nadie te dijo que ibas a pasar las noches buscando prompts que no
            funcionan, armando copies desde cero a las 2 AM y lanzando campañas
            que "más o menos sirven".
          </p>
          <p className="font-bold text-white text-2xl mt-8" data-id="element-214">
            No es falta de talento.{' '}
            <span className="text-red-400" data-id="element-215">Es falta de un sistema.</span>
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-216">
        <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-6 md:p-10 shadow-lg" data-id="element-217">
          <ul className="space-y-6" data-id="element-218">
            {pains.map((pain, index) => <li key={index} className="flex gap-4 items-start" data-id="element-219">
                <XCircle className="text-red-500 shrink-0 mt-1" size={24} data-id="element-220" />
                <span className="text-gray-300 text-lg" data-id="element-221">{pain}</span>
              </li>)}
          </ul>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-222">
        <div className="text-center mt-14" data-id="element-223">
          <h3 className="text-3xl md:text-4xl font-bold text-green-400" data-id="element-224">
            ¿Y si esta fuera la última noche que pasó así?
          </h3>
        </div>
      </FadeIn>
    </section>;
}